export function areaChangeFunc() {
	
	let letChangeJs,letThisArea,letAreaList,letCountryArea,letSelectBtn,letResponsibleCheck,letCurrentName;
	letChangeJs = $('#changeJs li');
	letCountryArea = $('section.countryList');
	letSelectBtn = $('.selectBtn');
	
	//サブナビゲーションクリック時
	letChangeJs.on('click',function(){
		letResponsibleCheck = $('#responsibleCheck').width();
		
		//クラス取得
		letThisArea = $(this).attr('class');
		//表示するリスト
		letAreaList = $('section.'+letThisArea);
		
		if ($(letAreaList).css('display') == 'none') {
			//取得したクラスのリストのみ表示
			
			letCountryArea.not(letAreaList).css('display','none');
			letAreaList.css('display','block');
			//マップと連動
			$('g').removeClass('current');
			$('g#'+letThisArea).addClass('current');
		}
		
		//currentクラス付与
		letChangeJs.removeClass('current');
		$(this).addClass('current');
		
		//SP時、サブナビクリック時閉じる
		if(letResponsibleCheck == '2') {
			$('#changeJs').slideUp(500);
			letSelectBtn.removeClass('open');
		}
		
		//クリックしたエリア名取得
		letCurrentName = $(this).html();
		//セレクトボタンに代入
		$('.currentItem').html(letCurrentName);
		
	});
	
	//SP表示時、セレクトボタンクリック時
	letSelectBtn.on('click',function(){
		//サブナビゲーション表示切り替え
		$('#changeJs').slideToggle(500);
		$(this).toggleClass('open');
	});
	
}